import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Catches failures from a lazily-loaded route chunk (React.lazy/import()) —
 * e.g. a stale deploy hash or a flaky network request for the chunk file.
 * Deliberately narrow: no stack traces, no automatic/infinite reload.
 * "Tentar novamente" remounts the subtree (re-triggers the dynamic import).
 */
export class RouteChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, attempt: 0 };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('[Super Admin] Falha ao carregar módulo da rota', error);
  }

  handleRetry() {
    this.setState((s) => ({ error: null, attempt: s.attempt + 1 }));
  }

  render() {
    const { error, attempt } = this.state;
    if (!error) {
      // Key forces a clean remount of the lazy subtree on retry.
      return <React.Fragment key={attempt}>{this.props.children}</React.Fragment>;
    }

    return (
      <div
        className="content"
        style={{
          padding: 40,
          textAlign: 'center',
          color: 'var(--text-secondary)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)' }}>
          Não foi possível carregar esta página
        </div>
        <div style={{ fontSize: 13, maxWidth: 420, lineHeight: 1.5 }}>
          Isso costuma acontecer após uma atualização do sistema ou uma falha de rede.
          Tente novamente ou volte ao dashboard.
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button type="button" className="btn ghost" onClick={this.handleRetry}>
            Tentar novamente
          </button>
          <Link to="/dashboard" className="btn primary">
            Ir ao dashboard
          </Link>
        </div>
      </div>
    );
  }
}
